import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQ } from "@/data/book";
import { Reveal } from "./Reveal";

export const Faq = () => (
  <section id="faq" className="bg-cream py-28 text-navy-deep sm:py-36" data-testid="faq-section">
    <div className="mx-auto max-w-4xl px-5 sm:px-8">
      <Reveal>
        <p className="mb-6 flex items-center gap-4 text-xs font-semibold uppercase tracking-[0.3em] text-bronze">
          <span className="h-px w-10 bg-bronze/60" aria-hidden="true" />
          Časté otázky
        </p>
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="font-serif text-4xl font-medium leading-[1.08] tracking-tight sm:text-5xl">
          Co tě možná <span className="italic text-bronze">zajímá</span>
        </h2>
      </Reveal>

      <Reveal delay={0.15} className="mt-14">
        <Accordion type="single" collapsible className="border-t border-navy-deep/10">
          {FAQ.map((item, i) => (
            <AccordionItem key={item.q} value={`faq-${i}`} className="border-navy-deep/10">
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="py-6 text-left font-serif text-xl font-medium text-navy-deep hover:no-underline sm:text-2xl"
              >
                {item.q}
              </AccordionTrigger>
              <AccordionContent
                data-testid={`faq-content-${i}`}
                className="pb-7 text-base leading-relaxed text-navy-deep/70"
              >
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
